import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Layout from "../Components/Layout/Layout";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { faqListAction } from "../Redux/Action/faqAction";
import { toast } from "react-hot-toast";

export default function FAQs() {
  const dispatch = useDispatch();
  const location = useLocation();
  const faqlist = useSelector((state) => state.faqSlice.faquestions);
  const [activeKey, setActiveKey] = useState(undefined);

  useEffect(() => {
    dispatch(faqListAction());
  }, []);

  useEffect(() => {
    if (faqlist?.length > 0 && location.hash) {
      const hash = location.hash.substring(1);
      const index = faqlist.findIndex(
        (faq, i) => String(101 + i) === hash
      );

      if (index !== -1) {
        setActiveKey(index);
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }, 100);
      } else {
        toast.error(`FAQ #${hash} could not be found.`);
        // Remove the invalid hash from the URL without refreshing the page
        window.history.replaceState(null, null, window.location.pathname + window.location.search);
      }
    }
  }, [faqlist, location.hash]);

  return (
    <Layout>
      <Container fluid>
        <Row className="mt-2">
          <Col lg={10}></Col>
          <Col lg={2} className="d-flex align-items-center justify-content-end">
            <div className="d-flex top-bar">
              
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center ">
          <Col lg={7} className="mt-4">
            {" "}
            <div className="cmn-card-color mt-4 pb-4 pt-4">
              <div className="back-page-title">
                <Link to="/help-support">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                  >
                    <path
                      d="M13.75 5.5L8.25 11L13.75 16.5"
                      stroke="#CCD2E3"
                      strokeWidth="2"
                    />
                  </svg>
                </Link>
              </div>
              <div className="student-view">
                <h2 className="mb-2">FAQs</h2>
                

                <section className="faq-accordon-sec">
                  <Container fluid>
                    <Row>
                      <Col lg={12}>
                        <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
                          {Array.isArray(faqlist) && faqlist.length > 0 ? (
                            faqlist.map((res, index) => {
                              const faqId = String(101 + index);
                              return (
                                <Accordion.Item
                                  eventKey={index}
                                  key={res?._id}
                                  id={faqId}
                                >
                                  <Accordion.Header>
                                    <p>
                                      Teacher
                                      <span>{res?.title}</span>
                                    </p>
                                  </Accordion.Header>
                                  <Accordion.Body>
                                    {res?.details}
                                  </Accordion.Body>
                                </Accordion.Item>
                              );
                            })
                          ) : (
                            <div className="data-not-found">
                              <p>No Data Found</p>
                            </div>
                          )}
                        </Accordion>
                      </Col>
                    </Row>
                  </Container>
                </section>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}
